import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, Divider, List, ListItemButton, ListItemSecondaryAction, ListItemText } from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const SubRubroCatalogo = (props) => {
    const { isLoggedIn } = useSelector(state => state.account)
    const { setDrawerOpen, setCategorias, rubro, categorias, label } = props
    const [collapseOpen, setCollapseOpen] = useState(false)
    const navigate = useNavigate()

    return (
        <>
            <List component="div" disablePadding >
                <ListItemButton onClick={() => { setDrawerOpen(false); setCategorias(label, rubro, ""); navigate(isLoggedIn ? "/products" : "/catalogo") }} key={rubro.rubroDescription} sx={{ pl: 5 }}>
                    <ListItemText primary={rubro} primaryTypographyProps={{ fontSize: "14px" }} />
                </ListItemButton>
                <ListItemSecondaryAction>
                    <ListItemButton onClick={() => setCollapseOpen(!collapseOpen)} key={rubro.rubroDescription} sx={{ fontSize: "12px", pl: 2 }}>
                        {collapseOpen ? <ExpandLess fontSize='small' /> : <ExpandMore fontSize='small' />}
                    </ListItemButton>
                </ListItemSecondaryAction>
            </List>
            <Divider />
            <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
                {
                    categorias[label][rubro].map(item => (
                        <List key={`${item.subRubroDescription}-${item.rubroId}`} component="div" disablePadding >
                            <ListItemButton onClick={() => { setDrawerOpen(false); setCategorias(label, rubro, item.subRubroDescription); navigate(isLoggedIn ? "/products" : "/catalogo") }} sx={{ pl: 8 }}>
                                <ListItemText primary={item.subRubroDescription} primaryTypographyProps={{ fontSize: "13px" }} />
                            </ListItemButton>
                        </List>
                    ))
                }
            </Collapse>
        </>
    )
}

export default SubRubroCatalogo